export default __webpack_public_path__ + "static/media/ET3.f481b4e7.png";